const currentNews = {
  slug: 'paranoia-virtuosa',

  category: 'Cultura de ejecución',

  date: '2 de junio de 2026',

  readTime: 5,

  title: 'Paranoia Virtuosa: la cultura que sostiene la ejecución perfecta',

  description:
    'Cuando el equipo nunca sabe si el cliente es real o incógnito, entrega siempre su mejor versión. Un caso académico de Roberto del Río sobre cómo la evaluación constante se vuelve cultura.',

  image: 'https://www.tcglatam.com/_next/image?url=https%3A%2F%2Fimages.unsplash.com%2Fphoto-1556761175-5973dc0f32e7%3Fq%3D80%26w%3D1600%26auto%3Dformat%26fit%3Dcrop&w=1080&q=75',

  content: [
    {
      type: 'paragraph',
      text: 'La paranoia virtuosa describe un estado de alerta profesional permanente que nace de una idea simple: la posibilidad constante de ser evaluado —por un cliente incógnito o una auditoría externa— mantiene al equipo siempre en su mejor versión.',
    },

    {
      type: 'paragraph',
      text: 'No se trata de estrés negativo ni de vigilancia punitiva. Es justo lo contrario: una cultura de cumplimiento proactivo donde el estándar no se relaja, porque nunca se sabe si la persona que entra a la tienda es un cliente real o un evaluador.',
    },

    {
      type: 'heading',
      text: 'El origen del concepto',
    },

    {
      type: 'paragraph',
      text: 'El término fue desarrollado por Roberto del Río, profesor del diplomado en Retail, a partir de resultados reales obtenidos con TCG. La observación central: los programas de Mystery Shopper y auditoría externa no solo miden la ejecución; la transforman.',
    },

    {
      type: 'heading',
      text: 'Cómo la evaluación se vuelve cultura',
    },

    {
      type: 'paragraph',
      text: 'Cuando un equipo sabe que cualquier visita puede ser evaluada, internaliza el protocolo de atención hasta volverlo automático. El cumplimiento deja de depender de la supervisión presente y pasa a ser parte de la identidad del local.',
    },

    {
      type: 'heading',
      text: 'De la percepción al hábito',
    },

    {
      type: 'paragraph',
      text: 'Un Mystery Shopper aislado genera un pico de atención puntual; un programa continuo, combinado con auditoría externa y herramientas de gestión interna, genera un hábito sostenido en el tiempo. La clave está en la consistencia de la medición.',
    },

    {
      type: 'heading',
      text: 'Resultados que se sostienen',
    },

    {
      type: 'paragraph',
      text: 'En las marcas donde se ha aplicado, la paranoia virtuosa se traduce en mejoras drásticas y estables en el cumplimiento de protocolos de atención, en los KPI de unidades por ticket y en la fidelización de clientes —no como un evento, sino como un nuevo piso de desempeño.',
    },

    {
      type: 'heading',
      text: 'Casos universitarios documentados',
    },

    {
      type: 'paragraph',
      text: 'Dos casos reales analizados en el diplomado muestran el impacto medible de la paranoia virtuosa sobre la ejecución y el negocio.',
    },

    {
      type: 'heading',
      text: 'Caso 1 · Cadena de farmacias (Panamá, 2021–2023)',
    },

    {
      type: 'list',
      items: [
        '99% — ofrecimiento del club de afiliados (desde 12%)',
        '98% — ofrecimiento de promocionales (desde 6%)',
        '80% — de las ventas provienen de afiliados (desde 20%)',
        '+43% — unidades por ticket en caja',
      ],
    },

    {
      type: 'heading',
      text: 'Caso 2 · Estación de servicio · combustibles (marca líder)',
    },

    {
      type: 'list',
      items: [
        '88% — mejora en el cumplimiento del protocolo',
        '75% — percepción positiva de atención (desde 28%)',
        '#1 — Top of Mind del mercado',
      ],
    },

    {
      type: 'heading',
      text: 'El rol de la tecnología',
    },

    {
      type: 'paragraph',
      text: 'Para que la cultura se sostenga, la medición debe ser objetiva y constante. La App de gestión, Teleaudit® y la red de Scouts permiten que la evaluación esté siempre presente sin disparar el costo de supervisión, cerrando el círculo entre cultura y datos.',
    },
  ],

  author: {
    name: 'Roberto del Río',
    description:
      'Director de Diplomado en Retail Management; profesor de Diplomado en Sport Retail, de pre y postgrado. MBA UEM, Ingeniero Comercial. Transforming Customer Experiences — Harvard Business School. Product Management — UC Berkeley Haas.',
  },
};

export default currentNews;
